export default __webpack_public_path__ + "static/media/thumb-NavIC-Chip-3.87ff3ce8.png";